/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import {
  Modal,
  Typography,
  Button,
  Box,
  Card,
  CardContent,
  CardActions,
  CardHeader,
  IconButton
} from '@mui/material';
import PropTypes from 'prop-types';
import { Close } from '@mui/icons-material';
import { useDispatch } from 'react-redux';
import PaymentAction from '../../store/actions/PaymentAction';

function ConfirmModal({ modalstatus, openmodal, onCloseModal }) {
  const { itemID, status } = modalstatus;

  const dispatch = useDispatch();

  const handleClickDelete = () => {
    if (status === 'resend') {
      dispatch(PaymentAction.resendInvoice(itemID, onCloseModal));
    } else if (status === 'duplicate') {
      dispatch(PaymentAction.copyInvoice(itemID, onCloseModal));
    } else if (status === 'delete') {
      dispatch(PaymentAction.deleteItem(itemID, onCloseModal));
    } else if (status === 'remind') {
      dispatch(PaymentAction.reminderInvoice(itemID, onCloseModal));
    }
  };

  let title;
  if (status === 'resend') {
    title = 'Resend';
  } else if (status === 'duplicate') {
    title = 'Duplicate';
  } else if (status === 'delete') {
    title = 'Delete';
  } else if (status === 'remind') {
    title = 'Remind';
  }

  let messageContent;
  if (status === 'resend') {
    messageContent = 'Are you sure <br /> you want to Resend this Invoice?';
  } else if (status === 'duplicate') {
    messageContent = 'Are you sure <br /> you want to Clone/Duplicate this Invoice?';
  } else if (status === 'delete') {
    messageContent = 'Are you sure <br /> you want to delete this Invoice?';
  } else if (status === 'remind') {
    messageContent = 'Are you sure <br /> you want to Remind this Invoice?';
  }

  return (
    <Modal
      className="cmn__delete__modal"
      open={openmodal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box>
        <Card>
          <CardHeader
            title={title}
            action={
              <IconButton
                aria-label="settings"
                onClick={() => {
                  onCloseModal();
                }}
              >
                <Close />
              </IconButton>
            }
          />
          <CardContent>
            <Typography
              variant="h3"
              component="h3"
              dangerouslySetInnerHTML={{ __html: messageContent }}
            />
          </CardContent>
          <CardActions sx={{ justifyContent: 'center' }}>
            <Button
              type="button"
              className="save__btn"
              variant="contained"
              color="secondary"
              size="medium"
              onClick={() => {
                handleClickDelete();
              }}
            >
              Yes
            </Button>
            <Button
              type="button"
              className="cancel__btn"
              variant="contained"
              color="info"
              // fullWidth
              size="medium"
              onClick={() => {
                onCloseModal();
              }}
            >
              No
            </Button>
          </CardActions>
        </Card>
      </Box>
    </Modal>
  );
}
ConfirmModal.propTypes = {
  modalstatus: PropTypes.objectOf(PropTypes.modalstatus).isRequired,
  openmodal: PropTypes.string.isRequired,
  onCloseModal: PropTypes.func.isRequired
};

export default ConfirmModal;
